import objectToQueryString from 'src/helpers/object-to-query-string'

import api, { make, Response } from '.'

export interface ReferenceCurrencies {
  code: string
  decimal_digits: number
  name: string
  reference_currency_id: number
}

export type GetAvailableCurrencyData = {
  reference_currencies: ReferenceCurrencies[]
}

type GetAvailableCurrencyProps = {
  code?: string
  name?: string
}

export async function getAvailableCurrency(
  props?: GetAvailableCurrencyProps
): Promise<Response<GetAvailableCurrencyData>> {
  const querystring = objectToQueryString({
    code: props?.code,
    name: props?.name,
    page_size: 10,
    page: 1
  })

  return make<GetAvailableCurrencyData>({
    axiosCall: api.get(`reference_currencies${querystring}`)
  })
}
